import api from "../proxy/config";
import axios from "./axiosConfig";
import {
  parseAdminNotificationsListResponse,
  validateAdminNotificationsListRequest,
  validateAdminNotificationsStateRequest,
} from "./schemas/adminNotificationsSchemas";

const getHeaders = () => ({
  Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
});

function toNumberOrZero(value) {
  return value == null ? 0 : Number(value);
}

function normalizeListResponseBody(body) {
  if (!body || typeof body !== "object") return {};
  const total = body.totalCount ?? body.total_count;
  return {
    ...body,
    totalCount: toNumberOrZero(total),
    page: toNumberOrZero(body.page),
    size: toNumberOrZero(body.size),
    items: Array.isArray(body.items) ? body.items : [],
  };
}

const adminNotificationsService = {
  list: async (data) => {
    const payload = validateAdminNotificationsListRequest(data);
    const response = await axios.post(api.adminNotificationList, payload, {
      headers: getHeaders(),
      skipGlobalErrorHandler: true,
    });
    const body = normalizeListResponseBody(response?.data);
    return parseAdminNotificationsListResponse(body);
  },
  state: async (data) => {
    const payload = validateAdminNotificationsStateRequest(data);
    return axios.post(api.adminNotificationState, payload, { headers: getHeaders() });
  },
};

export default adminNotificationsService;
 